import { NgModule } from '@angular/core';
import { GameListPickerComponent } from './game-list-picker.component';

@NgModule({
  imports: [GameListPickerComponent],
  declarations: [],
  schemas: [],
  exports: [GameListPickerComponent],
})
export class GameListPickerModule {}
